import PropTypes from 'prop-types';

import GoToStoreButton from './GoToStoreButton';
import FinishedOfferButtons from './GoToStoreButton/FinishedOfferButtons';

const ActionButton = ({
  gaEventCategory,
  isFinished,
  mostRelevantKeyword,
  offerCoupon = null,
  offerCta = null,
  offerId,
  offerSlug,
  offerUserVisibility,
}) => {
  if (isFinished) {
    return (
      <FinishedOfferButtons
        gaEventCategory={gaEventCategory}
        mostRelevantKeyword={mostRelevantKeyword}
        offerId={offerId}
        offerSlug={offerSlug}
        offerUserVisibility={offerUserVisibility}
      />
    );
  }

  return (
    <GoToStoreButton
      gaEventCategory={gaEventCategory}
      offerCoupon={offerCoupon}
      offerCta={offerCta}
      offerId={offerId}
      offerSlug={offerSlug}
      offerUserVisibility={offerUserVisibility}
    />
  );
};

ActionButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isFinished: PropTypes.bool.isRequired,
  mostRelevantKeyword: PropTypes.string.isRequired,
  offerCoupon: PropTypes.string,
  offerCta: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerSlug: PropTypes.string.isRequired,
  offerUserVisibility: PropTypes.string.isRequired,
};

export default ActionButton;
